import { useId, useMemo } from "react";
import { Layer } from "react-migration/layouts/map/Multilayer/types";

export function useLayer(layer: Layer) {
  const id = useId();
  return useMemo<Layer>(() => ({ ...layer, id: `${id}-${layer.id}` }), [id, layer]);
}
